import Marquee from "react-fast-marquee";

export const Ticker = () => {
  const words = ["Cement", "Vizag Steel TMT", "Structural Steel", "Bulk Trade", "Logistics", "Global Network"];
  return (
    <section data-testid="marquee-section" className="relative py-14 md:py-20 border-t border-white/10 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif text-[clamp(2.5rem,7vw,6rem)] text-transparent [-webkit-text-stroke:1px_rgba(245,245,240,0.28)] px-8">
              {w}
            </span>
            <span className="w-3 h-3 rounded-full bg-[#B87333]" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
